import { TabbedItemPage } from './TabbedItemPage';

export const PayRunsPage = () => <TabbedItemPage itemPath="/payroll/pay-runs" />;
